import { createApp } from "vue";
import App from "./journalButtons.vue";

createApp(App);
